package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import core.dateformat.utils.getDayOfMonthWithSuffix
import core.dateformat.utils.parseLocalDateOrNull
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryServicesGroupDateHeader(
    date: String?,
    modifier: Modifier = Modifier
) {
    val day = remember {
        val localDate = parseLocalDateOrNull(date) ?: return@remember null

        buildString {
            append(localDate.dayOfWeek.name.replaceFirstChar { it.uppercase() })
            append(" ")
            append(getDayOfMonthWithSuffix(localDate.dayOfMonth))
            append(" ")
            append(localDate.month.name.replaceFirstChar { it.uppercase() })
        }
    }

    Text(
        text = day.orEmpty(),
        color = MaterialTheme.esColorScheme.textSecondary,
        style = MaterialTheme.esTypography.p2Medium14,
        modifier = modifier,
    )
}